import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const ShopIcon: React.FC<Props> = () => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <Path
        d="M10 14V10.6667C10 10.4899 9.92976 10.3203 9.80474 10.1953C9.67971 10.0702 9.51014 10 9.33333 10H6.66667C6.48986 10 6.32029 10.0702 6.19526 10.1953C6.07024 10.3203 6 10.4899 6 10.6667V14"
        stroke="black"
        stroke-Wdth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.8491 6.8735C11.7102 6.74045 11.5252 6.66619 11.3328 6.66619C11.1404 6.66619 10.9554 6.74045 10.8165 6.8735C10.5065 7.16917 10.0945 7.33413 9.66614 7.33413C9.23774 7.33413 8.8258 7.16917 8.51581 6.8735C8.37686 6.74065 8.19204 6.66651 7.99981 6.66651C7.80757 6.66651 7.62275 6.74065 7.4838 6.8735C7.17378 7.16937 6.76169 7.33445 6.33314 7.33445C5.90458 7.33445 5.4925 7.16937 5.18247 6.8735C5.0435 6.74045 4.85853 6.66619 4.66614 6.66619C4.47375 6.66619 4.28878 6.74045 4.14981 6.8735C3.85037 7.15924 3.45532 7.32334 3.04156 7.33386C2.62779 7.34438 2.22492 7.20057 1.91134 6.93042C1.59777 6.66026 1.39594 6.28309 1.34513 5.87232C1.29432 5.46156 1.39817 5.04658 1.63647 4.70816L3.56247 1.91883C3.68468 1.7385 3.8492 1.59087 4.04166 1.48883C4.23411 1.38679 4.44864 1.33346 4.66647 1.3335H11.3331C11.5503 1.33341 11.7643 1.38639 11.9563 1.48782C12.1484 1.58925 12.3127 1.73607 12.4351 1.9155L14.3651 4.71016C14.6035 5.04885 14.7072 5.46414 14.6561 5.87512C14.605 6.2861 14.4027 6.66333 14.0886 6.93329C13.7745 7.20325 13.3712 7.34661 12.9572 7.33544C12.5432 7.32426 12.1482 7.15935 11.8491 6.87283"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.6665 7.2998V12.6665C2.6665 13.0201 2.80698 13.3592 3.05703 13.6093C3.30708 13.8593 3.64622 13.9998 3.99984 13.9998H11.9998C12.3535 13.9998 12.6926 13.8593 12.9426 13.6093C13.1927 13.3592 13.3332 13.0201 13.3332 12.6665V7.2998"
        stroke="black"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default ShopIcon;
